import styled, { css } from 'styled-components';
import { Box, Avatar } from '@bechtel/gds';

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
    margin-right: ${theme.spacings[300]};
  `}
`;

export const StencilItemStyled = styled(Box).attrs({
  mr: { sm: '400' },
  my: { sm: '200' },
  alignItems: { sm: 'center' },
})`
  border-width: 1px !important;
  cursor: pointer;
  width: fit-content;
  ${({ theme }) => css`
    padding-right: ${theme.spacings[300]};
    &:hover {
      background: ${theme.colors.grey[100]};
      border-radius: calc(${theme.radii[800]} + ${theme.radii[800]});
      .close-icon {
        visibility: visible;
      }
    }
    .close-icon {
      visibility: hidden;
    }
  `}
`;

export const BoxStyled = styled(Box).attrs({
  px: { sm: '600' },
  py: { sm: '400' },
})`
  ${({ theme }) => css`
    cursor: pointer;
    border-left: 1px solid ${theme.colors.grey[300]};
  `}
`;
